import { createFileRoute } from "@tanstack/react-router";
import EsServicePage from "@/pages/es/EsServicePage";
import { esTmsDepression } from "@/pages/es/esServiceData";
import { SITE_URL, buildHreflang } from "@/lib/i18n/locale";

const ES_URL = `${SITE_URL}/es/services/depression`;

export const Route = createFileRoute("/es/services/depression")({
  head: () => ({
    meta: [
      { title: "TMS para la depresión | Neuro Wellness TMS" },
      {
        name: "description",
        content:
          "Centro de especialistas en TMS y tratamiento de la depresión en Coral Springs, FL. Terapia autorizada por la FDA cuando los medicamentos no dan suficiente.",
      },
      {
        property: "og:title",
        content: "TMS para la depresión | Neuro Wellness TMS",
      },
      {
        property: "og:description",
        content:
          "Tratamiento TMS autorizado por la FDA para la depresión resistente al tratamiento en Coral Springs, FL.",
      },
      { property: "og:url", content: ES_URL },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "es_ES" },
      { name: "twitter:card", content: "summary_large_image" },
      {
        name: "twitter:title",
        content: "TMS para la depresión | Neuro Wellness TMS",
      },
      {
        name: "twitter:description",
        content:
          "Tratamiento TMS autorizado por la FDA para la depresión resistente al tratamiento en Coral Springs, FL.",
      },
    ],
    links: [
      { rel: "canonical", href: ES_URL },
      ...buildHreflang("/services/depression"),
    ],
  }),
  component: () => <EsServicePage cfg={esTmsDepression} />,
});
